export const getMax = (x, y) => {
  return Math.max(Array.isArray(x) ? Math.max(...x) : parseFloat(x), Array.isArray(y) ? Math.max(...y) : parseFloat(y) );
}

export const getMin = (x, y) => {
  return Math.min(Array.isArray(x) ? Math.min(...x) : parseFloat(x), Array.isArray(y) ? Math.min(...y) : parseFloat(y) );
}

export const getMaxMin = (x, y) => {
  return {
    max: getMax(x, y),
    min: getMin(x, y)
  }
}